/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
import type { UserDetails } from "../models/UserDetails";
import type { UserDetailsUpdate } from "../models/UserDetailsUpdate";
import type { UserEmailResend } from "../models/UserEmailResend";
import type { UserRegistration } from "../models/UserRegistration";

export class UserDetailsService {
    /**
     * Register user with initial subscriptions
     * This can be done without authentication. Repeated invocation will send another confirmation email for unverified user.
     * @param requestBody Registered user with initial subscriptions
     * @returns UserDetails User registered
     * @throws ApiError
     */
    public static registerUser(
        requestBody?: UserRegistration,
    ): CancelablePromise<UserDetails> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/user",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                400: `Invalid request schema`,
                500: `Service failure`,
            },
        });
    }
    /**
     * Resend a verification email
     * This will resend a verification or a welcome email depending on user verification state.
     * @param requestBody User email address
     * @returns void
     * @throws ApiError
     */
    public static resendUserEmail(
        requestBody?: UserEmailResend,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/user/resending",
            body: requestBody,
            mediaType: "application/json",
            errors: {
                500: `Service failure`,
            },
        });
    }
    /**
     * Get user
     * This will retrieve full user details.
     * @param userId The unique user id which can be found in subject claim of the JWT.
     * @returns UserDetails Successful operation
     * @throws ApiError
     */
    public static getUser(userId: any): CancelablePromise<UserDetails> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/users/{userId}",
            path: {
                userId: userId,
            },
            errors: {
                401: `Unauthorised usage`,
                403: `Forbidden usage`,
                404: `User not found`,
                500: `Service failure`,
            },
        });
    }
    /**
     * Update user
     * This will update user details.
     * @param userId The unique user id which can be found in subject claim of the JWT.
     * @param requestBody Update existing user
     * @returns void
     * @throws ApiError
     */
    public static updateUser(
        userId: any,
        requestBody?: UserDetailsUpdate,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: "PUT",
            url: "/users/{userId}",
            path: {
                userId: userId,
            },
            body: requestBody,
            mediaType: "application/json",
            errors: {
                400: `Invalid request schema`,
                401: `Unauthorised usage`,
                403: `Forbidden usage`,
                404: `User not found`,
                500: `Service failure`,
            },
        });
    }
    /**
     * Delete user
     * This will delete all data associated with the user (subscriptions, notes and fund folders).
     * @param userId The unique user id which can be found in subject claim of the JWT.
     * @returns void
     * @throws ApiError
     */
    public static deleteUser(userId: any): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/users/{userId}",
            path: {
                userId: userId,
            },
            errors: {
                401: `Unauthorised usage`,
                403: `Forbidden usage`,
                404: `User not found`,
                500: `Service failure`,
            },
        });
    }
}
